import { MinusIcon, PlusIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { type DecimalCounterInputProps, useDecimalCounterInput } from './use-decimal-counter-input';

import { Button } from '../../../button';
import { Input } from '../input';

export const DecimalCounterInput = (props: DecimalCounterInputProps) => {
  const { inputValue, min, decrement, increment, handleChangeInput, handleBlur, className, rest } =
    useDecimalCounterInput(props);

  return (
    <section className="flex flex-nowrap items-end gap-x-1">
      {!props.disabled && (
        <div className="border-c-border border-b px-1 pb-1.5">
          <Button
            size="xs"
            disabled={parseFloat(`${inputValue}`) <= min}
            aria-label="Minus"
            as="outline"
            onClick={decrement}
            icon={MinusIcon}
          />
        </div>
      )}
      <Input
        {...rest}
        containerProps={{ className: 'min-w-3' }}
        className={twMerge('px-1 text-center placeholder:font-medium placeholder:opacity-70', className)}
        type="text"
        value={inputValue}
        onChange={handleChangeInput}
        onBlur={handleBlur}
        labelProps={{ className: props.disabled ? '' : '-left-8 w-[calc(100%_+_4rem)]' }}
      />
      {!props.disabled && (
        <div className="border-c-border border-b px-1 pb-1.5">
          <Button size="xs" aria-label="Plus" as="outline" onClick={increment} icon={PlusIcon} />
        </div>
      )}
    </section>
  );
};
